import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import FeedbackWrapper from "../Components/FeedbackWrapper";
import FeedbackBanner from "../Components/FeedbackBanner";

const Feedback = () => {
  const seoData = getSEOData("/feedback");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <FeedbackBanner />
      <FeedbackWrapper />
    </>
  );
};

export default Feedback;
